export type TUpdateBusinessNameUI = {
  name: string;
  propertyManagementId: string;
};

export type TUpdateBusinessName = {
  name: string;
  propertyManagementId: string;
};

export enum ELandlordStatusDB {
  ACTIVE = 'ACTIVE',
  TEST = 'TEST',
  PROSPECT = 'PROSPECT',
  NON_LANDLORD = 'NON_LANDLORD',
  INACTIVE = 'INACTIVE',
}

export enum ELandlordStatusUI {
  ACTIVE = 'Active',
  TEST = 'Test',
  PROSPECT = 'Prospect',
  NON_LANDLORD = 'Non-landlord',
  INACTIVE = 'Inactive',
}
